import React from "react";

import { bindActionCreators } from "redux";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import CloudFlyerAPI from "../../api/CloudFlyerAPI";
import { receiveError } from "../../api/http";
import moment from "moment";
import prettysize from '../../utils'


import { Modal, Button, message, Table, Tooltip, Input, Space } from "antd";
import {
  DeleteFilled
} from '@ant-design/icons';

import "./adminAccount.scss";

const { Search } = Input;


class AdminAccount extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      accountList: [],
      pageSize: 50,
      page: 1,
      total: 0,
      accountName: ""
    };
    this.onSearch = this.onSearch.bind(this);
    this.handleDeleteClick = this.handleDeleteClick.bind(this);
  }
  onSearch(value){
    console.log(value)
    console.log(this.state.searchUser,"get done")
    this.setState({
      loading: true,
      accountName: value
    });
    CloudFlyerAPI.user_account
        .fetchAllAccounts(this.state.pageSize, this.state.page, value)
        .then(({ data }) => {
          this.setState({
            loading: false,
            accountList: data.data,
            pageSize: data?.options?.pageSize,
            page: data?.options?.page,
            total: data?.total,
          });
        })
        .catch((err) => {
          const msg = receiveError(null, err).message;
          message.error(msg);
        });
  }
  componentDidMount() {
    this.setState({
      loading: true,
    });
    this.getAllAccounts();
  }
  getAllAccounts(){

    CloudFlyerAPI.user_account
        .fetchAllAccounts(this.state.pageSize, this.state.page, this.state.accountName)
        .then(({ data }) => {
          this.setState({
            loading: false,
            accountList: data.data,
            pageSize: data?.options?.pageSize,
            page: data?.options?.page,
            total: data?.total,
          });
        })
        .catch((err) => {
          const msg = receiveError(null, err).message;
          message.error(msg);
        });
  }

  onPageChange = page => {
    this.setState({page:page, loading: true})

    CloudFlyerAPI.user_account
      .fetchAllAccounts(this.state.pageSize, page, this.state.accountName)
      .then(({ data }) => {
        this.setState({
          loading: false,
          accountList: data.data,
          pageSize: data?.options?.pageSize,
          page: data?.options?.page,
          total: data?.total,
        });
      })
      .catch((err) => {
        const msg = receiveError(null, err).message;
        message.error(msg);
      });
  }

  handleDeleteClick(id) {
    CloudFlyerAPI.user_account
        .deleteAccountAPI(id)
        .then(({data}) => {
          console.log(data)
          this.setState({
            loading: true,
          });
          this.getAllAccounts();
        })
        .catch((err) => {
          const msg = receiveError(null, err).message;
          message.error(msg);
        });
  }

  on_click_detail(e, id, name) {
    this.props.history.push("/usageDetail/?id=" + id + "&name=" + name)
  }

  downloadAccount = () => {

    CloudFlyerAPI.user_account
        .downloadAccountReport()
        .then(({data}) => {
            console.log(data);

            //var startDate = new Date(this.state.startDate);
            //var endDate = new Date(this.state.endDate);
            var encodedUri = encodeURI("data:text/csv;charset=utf-8," + data);
            var link = document.createElement("a");
            link.setAttribute("href", encodedUri);
            link.setAttribute("download", "Account-Report"+ ".csv");
            document.body.appendChild(link); // Required for FF

            link.click();
        })
        .catch((err) => {
            const msg = receiveError(null, err).message;
        });

};

  render() {

    let status = new Map()
    status.set(true, 'Active')
    status.set(false, 'Inactive')

    const { providers } = this.state;
    const { match } = this.props;
    const { user, history } = this.props;

    const showDeleteConfirm = (
        e,
        handleDeleteClick,
        id) => {
      e.stopPropagation()
      Modal.confirm({
        title: `Are you sure you want to Delete this Account?`,
        content:
            "",
        onOk() {
          handleDeleteClick(id)
        }
      })
    }
    const columns = [
      {
        title: "Account Name",
        dataIndex: "accountName",
        key: "accountName",
        ellipsis: {
          showTitle: false,
        },
        render: (accountName) => (
          <Tooltip placement="topLeft" title={accountName}>
            {accountName}
          </Tooltip>
        ),
        width: 150,
      },
      {
        title: "Total Usage (Previous Month)",
        dataIndex: "totalUsage",
        key: "totalUsage",
        width: 130,
      },
      {
        title: "Total Cost (Previous Month)",
        dataIndex: "totalCost",
        key: "totalCost",
        width: 130,
      },
      {
        title: "Created Date",
        dataIndex: "date",
        key: "date",
        width: 130,
      },
      {
        title: "Status",
        dataIndex: "status",
        key: "status",
        width: 100,
      },
      {
        title: "Users",
        dataIndex: "userCount",
        key: "userCount",
        width: 100,
      },
      {
        title: 'Action',
        dataIndex: 'action',
        key: 'action',
        width: 100,
        ellipsis: {
          showTitle: false,
        },
        render: action => (
            <div className="userActions">
              <Tooltip placement="topLeft" title="Detail">
              <Button
                  className="replication-delete-btn"
                  icon="arrow-right"
                  onClick={(e) =>
                      this.on_click_detail(e, action.detailData.id, action.detailData.name)
                  }
              />
              </Tooltip>
              <Tooltip placement="topLeft" title="Delete User">
                <DeleteFilled onClick={e =>
                    showDeleteConfirm(e, this.handleDeleteClick, action.id,)
                }/>
              </Tooltip>
            </div>
        ),
      }
    ];

    let data = this.state?.accountList?.map((t, index) => {
      return {
        key:t.id,
        id: t.id,
        accountName: t.name,
        totalUsage: prettysize(t.lastMonthUsage),
        totalCost: t.lastMonthCost,
        date: moment(t.createDate).format("MM/DD/YYYY"),
        status: status.get(t.active),
        userCount: t.usersCount,
        action: {
          id: t.id,
          detailData:{id : t.id, name: t.name}
        }
      };
    });

    return (
      <div className="admin-account-list-wrapper">
        <div className="header">
          <div className="left-wrapper">
            <h2>Account</h2>
          </div>
          <div className="right-wrapper">
            <Search className="search-user" placeholder="Search Account Name" onSearch={this.onSearch} enterButton />
            <Button
              className="add-account-btn"
              type="primary"
              onClick={() => history.push("/addNewAccount")}
            >
              Add New Account
            </Button>
            <Button
              className="add-account-btn"
              type="primary"
              onClick={() => this.downloadAccount()}
            >
              Download Account Report
            </Button>
          </div>
        </div>
        <div className="admin-account-list">
          <Table
            loading={this.state.loading}
            columns={columns}
            dataSource={data}
            pagination={{
              onChange: this.onPageChange,
              total: this.state.total,
              current: this.state.page,
              showTotal: (total, range) =>
                `${range[0]}-${range[1]} of ${total} items`,
              pageSize: this.state.pageSize,
            }}
            scroll={{ y: 600 }}
          />
        </div>
      </div>
    );
  }
}

export default withRouter(AdminAccount);
